<template>
  <div class="step">
    <div class="exercise">
      <h1>Step 5</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step-five'
}
</script>
